// Central content/config for Kothari Classes
export const INSTITUTE = {
  name: "Kothari Classes",
  tagline: "CBSE | ICSE | State Board Forum",
  promise: "Building Future Toppers with Excellence, Discipline & Results",
  logo: "/assets/logo.png",
  logo_symbol: "/assets/logo-symbol.png",
  director: {
    name: "Bipin Shah Sir",
    role: "Director · Kothari Classes",
    photo: "/assets/bipin-shah.jpg",
  },
  phone: "+91 74994 76736",
  phone_short: "7499476736",
  phone_raw: "917499476736",
  phones: [
    { label: "Primary", number: "+91 74994 76736", raw: "917499476736" },
    { label: "Admissions", number: "+91 99753 09002", raw: "919975309002" },
    { label: "Senior Section", number: "+91 97679 02095", raw: "919767902095" },
    { label: "Main Section", number: "+91 94044 92199", raw: "919404492199" },
  ],
  email: "kothariclassesjalgaon@gmail.com",
  whatsapp_number: "917499476736",
  whatsapp_message: "Hi, I would like to know more about Kothari Classes admissions.",
  socials: {
    instagram: "https://www.instagram.com/kothari.classes?igsh=bGN3eGZkbW16eTdu",
    facebook: "https://www.facebook.com/share/1Cs7WevQiF/",
    youtube: "#",
  },
};

export const BRANCHES = [
  {
    id: "baliram-peth",
    name: "Baliram Peth Branch",
    short: "Main Branch",
    address: "205, Baliram Peth, Near Zilha Parishad, Jalgaon, Maharashtra",
    phone: "+91 74994 76736",
    phone_raw: "917499476736",
    whatsapp_raw: "917499476736",
    hours: "All Batches · 7:00 AM – 9:00 PM",
    map: "https://www.google.com/maps?q=Baliram+Peth+Jalgaon&output=embed",
    directions: "https://share.google/W42lanA5krpU3ikW3",
  },
  {
    id: "yogeshwar-nagar",
    name: "Yogeshwar Nagar Branch",
    short: "Foundation & Kids",
    address: "Yogeshwar Nagar, Behind Kashibai School, Old Khedi Road, Jalgaon",
    phone: "+91 96650 96736",
    phone_raw: "919665096736",
    whatsapp_raw: "919665096736",
    hours: "All Batches · 7:00 AM – 9:00 PM",
    map: "https://www.google.com/maps?q=Yogeshwar+Nagar+Jalgaon&output=embed",
    directions: "https://share.google/0cKcmSrcIWxnrSOML",
  },
];

export const PROGRAMS = [
  {
    key: "main",
    label: "Main Section",
    range: "4th – 10th",
    description: "All subjects coaching across CBSE, ICSE and State Board. Concept clarity, regular tests and dedicated doubt hours.",
    highlights: ["All Subjects", "Board Aligned", "Weekly Tests", "PTA Reports"],
    image: "/assets/main-section.png",
    index: "01",
  },
  {
    key: "senior",
    label: "Senior Section",
    range: "11th – 12th Science",
    description: "Integrated 11th & 12th Science with IIT-JEE, NEET and MHT-CET tracks. Small batches, expert faculty, benchmark tests.",
    highlights: ["IIT-JEE", "NEET", "MHT-CET", "Boards 12th"],
    image: "/assets/senior-section.png",
    index: "02",
  },
  {
    key: "foundation",
    label: "Foundation Course",
    range: "with IIT-JEE | NEET Preparation",
    description: "Early competitive foundation (8th – 10th) aligned with IIT-JEE & NEET pathways. Build reasoning, aptitude and subject depth from the ground up.",
    highlights: ["IIT-JEE Track", "NEET Track", "NTSE & Olympiads", "Strong Fundamentals"],
    image: "/assets/foundation-section.png",
    index: "03",
  },
];

export const SUBJECTS = [
  { name: "Mathematics", icon: "Sigma" },
  { name: "Physics", icon: "Atom" },
  { name: "Chemistry", icon: "FlaskConical" },
  { name: "Biology", icon: "Leaf" },
  { name: "History", icon: "ScrollText" },
  { name: "Geography", icon: "Globe2" },
  { name: "Economics", icon: "LineChart" },
  { name: "Political Science", icon: "Landmark" },
  { name: "English", icon: "BookOpen" },
  { name: "Hindi", icon: "Languages" },
  { name: "Marathi", icon: "BookType" },
  { name: "Sanskrit", icon: "BookMarked" },
];

export const WHY_US = [
  { title: "Small Batch Sizes", desc: "Capped batches so every student gets focused attention.", icon: "Users" },
  { title: "Personal Attention", desc: "1-on-1 mentorship, doubt sessions, individual growth plans.", icon: "UserCheck" },
  { title: "Regular Tests", desc: "Weekly assessments, chapter tests and full board simulations.", icon: "ClipboardCheck" },
  { title: "Result-Oriented", desc: "Structured methodology proven across CBSE, ICSE & State boards.", icon: "Trophy" },
  { title: "Experienced Faculty", desc: "Subject experts with decades of board and entrance experience.", icon: "GraduationCap" },
  { title: "Performance Tracking", desc: "Detailed progress reports, regular feedback, and parent updates to ensure continuous improvement.", icon: "LineChart" },
];

export const STATS = [
  { value: "35+", label: "Years of Excellence" },
  { value: "10,000+", label: "Students Mentored" },
  { value: "95%+", label: "Board Results" },
  { value: "2", label: "Branches in Jalgaon" },
];

export const TOPPER_CATEGORIES = [
  {
    key: "mhtcet",
    title: "MHT-CET Toppers",
    accent: "Engineering · Pharmacy Gateway",
    toppers: [
      { name: "Tejal Sapkale", score: "99.28", unit: "Percentile", photo: "/assets/tejal-sapkale.png" },
      { name: "Chetan Deliwala", score: "98.57", unit: "Percentile", photo: "/assets/chetan-deliwala.jpg" },
      { name: "Dhiraj Devtalu", score: "97.50", unit: "Percentile", photo: "/assets/dhiraj-devtalu.png" },
      { name: "Ronak Pardeshi", score: "96.22", unit: "Percentile", photo: "/assets/ronak-pardeshi.png" },
    ],
  },
  {
    key: "jee",
    title: "JEE Mains Toppers",
    accent: "IIT · NIT Pathway",
    toppers: [
      { name: "Omkar Dolhare", score: "98.63", unit: "Percentile", photo: "/assets/omkar-dolhare.jpg" },
      { name: "Jatin Mali", score: "97.67", unit: "Percentile", photo: "/assets/jatin-mali.jpg" },
      { name: "Naresh Jain", score: "95.47", unit: "Percentile" },
      { name: "Yuvraj Thakur", score: "93.37", unit: "Percentile" },
    ],
  },
  {
    key: "neet",
    title: "NEET Achievers",
    accent: "Medical Admissions",
    toppers: [
      { name: "Suhani More", score: "B.D.S", unit: "Admission", photo: "/assets/suhani-more.jpg" },
      { name: "Roshni Phalak", score: "B.A.M.S", unit: "Admission" },
      { name: "Tousif Khan", score: "M.B.B.S", unit: "Admission" },
      { name: "Yuvraj Chaudhari", score: "M.B.B.S", unit: "Admission" },
      { name: "Vijay Telangre", score: "B.D.S", unit: "Admission" },
      { name: "Ashish Talreja", score: "M.B.B.S", unit: "Admission" },
    ],
  },
];

export const BOARDS = ["CBSE", "ICSE", "State Board (Maharashtra)", "Not Sure"];
export const CLASSES = [
  "4th", "5th", "6th", "7th", "8th", "9th", "10th",
  "11th Science", "12th Science",
  "NEET / JEE / CET Repeater",
];

export const ADMISSION_STEPS = [
  { n: "01", title: "Inquiry", desc: "Fill the online form or call the branch to book a slot." },
  { n: "02", title: "Free Demo", desc: "Attend a live demo class and meet the faculty in person." },
  { n: "03", title: "Enroll", desc: "Secure your seat with a simple registration process." },
];

export const TESTIMONIALS = [
  {
    name: "Bhushan Rathod",
    role: "Senior Section Student",
    short: "Coaching taught me discipline and proper study habits.",
    quote: "The coaching class experience was a little different from school—there was more pressure to study, but the learning environment was serious and focused.",
    highlights: [
      "Long hours of study",
      "Tough competition",
      "Great teachers with strategies",
      "Mock tests and analysis",
      "Friends and study partners",
    ],
    rating: 5,
  },
  {
    name: "Namrata Kale",
    role: "3-year student · Kothari Classes",
    short: "Teaching methods are beyond excellence.",
    quote: "It's been 3 years I'm joined to Kothari classes. It's such a great experience. Students are provided with all the best educational facilities. Each and every student's doubts are cleared. Teaching methods are beyond excellence. Teachers are very supportive. Overall Kothari Classes is the best place to improve yourself.",
    rating: 5,
  },
  {
    name: "Omkar Dolhare",
    role: "JEE Mains Topper · 98.63 Percentile",
    short: "Regular chapter tests keep everything fresh.",
    quote: "Kothari Classes are the best! They really help you sharpen your skills so you can do your best on exam day. Regular chapter tests keep everything fresh. Classrooms are big and airy, making it comfortable to study.",
    rating: 5,
    photo: "/assets/omkar-dolhare.jpg",
  },
  {
    name: "Samiksha Rupani",
    role: "CBSE 10th Student",
    short: "A game-changer for my board preparation.",
    quote: "Studying at Kothari Classes for my 10th CBSE was a game-changer. All subjects under one roof with expert faculty made preparation seamless. Regular tests and feedback helped me improve and feel confident for board exams.",
    rating: 5,
  },
];
